import Vue from "vue"
import {slugify} from "@/helpers/slugify";

export default Vue.mixin({
  computed: {
    currentSelectedTab() {
      let index = 0;

      index = this.tabContent.findIndex(item => {
        return item.id === this.$route.query.tab || slugify(item.name) === this.$route.query.tab
      })

      if(index === -1) index = 0

      if(!this.tabContent[index]) {
        return {}
      }
      if(this.tabContent[index].subtabs && this.tabContent[index].subtabs.length) {
        let subIndex = 0;
        if(!this.$route.query.subtab) {
          return this.tabContent[index].subtabs[subIndex]
        }
        if(this.$route.query.subtab) {
          subIndex = this.tabContent[index].subtabs.findIndex(item => {
            return slugify(item.name) === this.$route.query.subtab
          })
        }
        if(subIndex === -1) subIndex = 0
        if(!this.tabContent[index].subtabs[subIndex]) {
          return {}
        }
        return this.tabContent[index].subtabs[subIndex]
      }
      return this.tabContent[index]
    }
  }
})